// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import AuditResult from '@deere/cps-it.warranty-model-factory/lib/audit-result';
import {FormattedMessage} from 'react-intl';

const AuditResultModalBody = props =>
    <div className='audit-result-modal-body'>
        <div className='description'>
            {props.auditResult.description}
        </div>
        <div className='ok-button'>
            <button
                className='button-primary'
                onClick={props.onConfirmation}
            >
                <FormattedMessage id='OK'/>
            </button>
        </div>
    </div>;

AuditResultModalBody.displayName = 'AuditResultModalBody';
AuditResultModalBody.propTypes = {
    auditResult: PropTypes.instanceOf(AuditResult).isRequired,
    onConfirmation: PropTypes.func.isRequired
};

export default AuditResultModalBody;



// WEBPACK FOOTER //
// ./src/reports/audit-summary/components/audit-result-modal/audit-result-modal-body.js